
<script>
import Favourite from '../../App/Common/ClubFavourite.vue';

export default {

    data: function () {
        return {
            selectedArea: null,
            clubs: [],
            clubAreas: {},
            clubSearch: '',
            favourites: [],
            favouritesCheck: false,
        }
    },
    props: [
        'url', 'favouriteListUrl'
    ],
    computed: {
        selectedAreaClubs() {
            return this.clubAreas[this.selectedArea];
        },
    },
    created() {
    },
    mounted() {
        this.getList();
        this.getFavouriteList();
    },
    watch: {
    },
    methods: {           
        filteredClubs() {
            var clubs = []; 
            for (var i = 0; i < this.clubs.length; i++) {
                if(this.selectedArea == null) {
                    if(this.clubs[i].title.toLowerCase().includes(this.clubSearch.toLowerCase())) {
                        clubs.push(this.clubs[i]);
                    }
                } else if(this.selectedArea === 'dublin') {
                    if(this.clubs[i].area === 'dun-laoghaire-rathdown-county-council' || this.clubs[i].area === 'dublin-city' || this.clubs[i].area === 'fingal' || this.clubs[i].area === 'south-dublin-county-council') {
                        clubs.push(this.clubs[i]);
                    } 
                }else {
                    if(this.clubs[i].title.toLowerCase().includes(this.clubSearch.toLowerCase()) && this.selectedArea == this.clubs[i].area) {
                        clubs.push(this.clubs[i]);
                    }
                }
            }
            var sorted = clubs.sort(function SortByTitle(a, b) { 
                return b.title < a.title ?  1
                    : b.title > a.title ? -1 
                    : 0;                   
            });
            return sorted;
        },
        getList() {
            axios
                .get(this.url,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.clubs = response.data.data;
                    this.generateClubAreas();
                    
                })
                .catch(error => {
                    console.log(error);
                });

        },
        generateClubAreas() {
            var i = 0;
            var self  = this;
            this.clubs.forEach(function (value, i) {
                
                if(!(value.area in self.clubAreas)) {
                    self.clubAreas[value.area] = {};                    
                }
                self.clubAreas[value.area][i] = value;
            });

            const ordered = {};
            Object.keys(self.clubAreas).sort().forEach(function(key) {
                ordered[key] = self.clubAreas[key];
            });
            this.clubAreas = ordered;
        },
        clubCount(index, usedArea) {
            var length = 0;
            if(index === 'dublin' && usedArea == 'map') {
                var areas = ['fingal', 'dublin-city', 'dun-laoghaire-rathdown-county-council', 'south-dublin-county-council'];
                areas.forEach(element => {
                    for( var key in this.clubAreas[element] ) {
                        ++length;
                    }
                });

                return length;
            }
            for( var key in this.clubAreas[index] ) {
                ++length;
            }
            return length;
        },
        setClubArea(area) {
            if(this.selectedArea == area) {
                this.selectedArea = null;
            } else {
                this.selectedArea = area;
            }
        },
        getFavouriteList() {
            axios
                .get(this.favouriteListUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.favourites = response.data.data;
                    this.favouritesCheck = true;
                })
                .catch(error => {
                    console.log(error);
                });

        },
    },
    components: {
        Favourite
    },

}
</script>
